import { render, staticRenderFns } from "./TemplateAmerican.vue?vue&type=template&id=7f0c8c6d&scoped=true"
import script from "./TemplateAmerican.vue?vue&type=script&lang=js"
export * from "./TemplateAmerican.vue?vue&type=script&lang=js"
import style0 from "./TemplateAmerican.vue?vue&type=style&index=0&id=7f0c8c6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0c8c6d",
  null
  
)

export default component.exports